<template lang="pug">
  v-container
    v-row
      v-spacer
      v-col.shrink
        v-btn.info(:href="orderURL" target="_blank")
          v-icon mdi-eye
          | &nbsp;VIEW ORDER PAGE
    v-row(justify="center")
      v-col(cols="12" md="10")
        v-card.mb-6(v-for="(claz, index) in clazz")
          v-card-text
            v-row
              v-col.py-0(cols="11")
                v-text-field(v-model="claz.title" label="Title")
              v-col.pl-1.pt-4(cols="1")
                v-btn(icon)
                  v-icon(large @click="claz.id ? removeClazz(claz.id, index) : clazz.splice(index, 1)") mdi-delete
            v-row
              v-col.py-0(cols="11")
                v-textarea.mb-2(v-model="claz.description" label="Description" auto-grow outlined hide-details row-height="13")
              v-col.pl-1.pt-0(cols="1")
                v-btn(icon :disabled="clazz.length <= 1 || index === 0")
                  v-icon(large @click="changeOrderUp(index)") mdi-menu-up
                v-btn(icon :disabled="clazz.length <= 1 || index === clazz.length - 1")
                  v-icon(large @click="changeOrderDown(index)") mdi-menu-down
            v-autocomplete.mb-3(v-model="claz.features" :items="features" item-text="name" item-value="id" label="Class Features" multiple chips hide-details)
              template(v-slot:selection="data")
                v-chip(v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeFeatures(data.item, index)")
                  v-avatar(left)
                    v-icon {{ data.item.icon }}
                  |       {{ data.item.text }}
              template(v-slot:item="data")
                template(v-if="typeof data.item !== 'object'")
                  v-list-item-content(v-text='data.item')
                template(v-else='')
                  v-list-item-avatar
                    v-icon {{ data.item.icon }}
                  v-list-item-content
                    v-list-item-title(v-html='data.item.text')
            v-autocomplete.mb-3(v-model="claz.options" :items="options" item-text="title" item-value="id" label="Options" multiple chips hide-details @change="defOptions[index] = [...getDefOptions(claz.options)]")
              template(v-slot:selection="data")
                v-chip [{{data.item.id}}-{{data.item.provider}}] {{ data.item.title + ' ( RM' + senToRM(data.item.sell_price) + ' )' }}
              template(v-slot:item="data")
                | [{{data.item.id}}-{{data.item.provider}}] {{ data.item.title + ' ( RM' + senToRM(data.item.sell_price) + ' )' }}
            v-select(v-model="claz.default_option" :items="defOptions[index]" item-text="title" item-value="id" label="Default Option")
              template(v-slot:selection="data")
                | [{{data.item.id}}-{{data.item.provider}}] {{ data.item.title + ' ( RM' + senToRM(data.item.sell_price) + ' )' }}
              template(v-slot:item="data")
                | [{{data.item.id}}-{{data.item.provider}}] {{ data.item.title + ' ( RM' + senToRM(data.item.sell_price) + ' )' }}
    v-footer(app inset padless color="transparent")
      v-row(justify="center")
        v-col(cols="8" style="background-color: #424242")
          v-row(justify="center")
            v-col.py-0(cols="6")
              v-btn(block color="red" @click="clazz.push({ title: '', description: '', features: [], options: [], product: $route.params.productID })" :disabled="!$store.state.groups.includes('Production')") Add Class
            v-col.py-0(cols="6")
              v-btn(block color="success" @click="saveClazz") Save Class
              span.caption.warning--text(v-if="!saveEnabled") Warning: Currently being edited by other user
</template>

<script>
export default {
  name: 'ClazzTab',
  props: ['language', 'refresh', 'saveEnabled'],
  data: () => ({
    // check: [],
    clazz: [],
    features: [],
    options: [],
    defOptions: []
  }),
  mounted () {
    setTimeout(() => {
      this.fetchClazz()
      this.fetchFeatures()
      this.fetchOptions()
    }, 200)
  },
  computed: {
    orderURL () {
      return process.env.VUE_APP_WEB_URL + '/order/' + this.$route.params.productID + '/?preview=1'
    }
  },
  watch: {
    refresh(val) {
      if (val === true) {
        setTimeout(() => {
          this.fetchClazz()
        }, 200)
      }
    }
  },
  methods: {
    fetchClazz () {
      let id = this.$route.params.productID
      this.$axios.get(`/clazzs/?product=${id}&locale=${this.language}&ordering=order`)
        .then(resp => {
          this.clazz = [...resp.data.results]
            this.clazz.forEach(cl => {
              this.defOptions.push(cl.options)
            })
          this.$emit('afterRefresh', false)
        })
    },
    fetchFeatures () {
      this.$axios.get('/features/?type=clazz&page_size=-1')
        .then(resp => {
          resp.data.results.forEach(f => {
            let feat = {}
            feat.id = f.id
            feat.icon = f.icon
            feat.text = f.featurelocales.filter(fl => fl.locale === this.language)[0].text
            this.features.push(feat)
          })
        })
    },
    fetchOptions () {
      let id = this.$route.params.productID
      this.$axios.get(`/options/?product=${id}`)
        .then(resp => {
          this.options = [...resp.data.results]
        })
    },
    getDefOptions (val) {
      let defOptions = []
      val.forEach(v => {
        defOptions.push(this.options.filter(o => o.id === v)[0])
      })
      return defOptions
      // console.log(val)
    },
    removeFeatures (item, ind) {
      const index = this.clazz[ind].features.indexOf(item.id)
      if (index >= 0) this.clazz[ind].features.splice(index, 1)
    },
    saveClazz () {
      if (this.clazz.length > 0) {
        let check = 0
        let incopt = []
        // let incopt = []
        this.clazz.forEach((c, index) => {
          if (c.id) {
            let data = {
              order: index + 1,
              title: c.title,
              description: c.description,
              features: [...c.features],
              default_option: (typeof(c.default_option) === "object" ? c.default_option.id : c.default_option)
            }
            this.$axios.patch(`/clazzs/${c.id}/`, data)
              .then(resp => {
                if (c.options.length > 0) {
                  c.options.forEach((o, index) => {
                    if (o.id) {
                      incopt.push(o.id)
                      this.$axios.patch(`/options/${o.id}/`, { clazz: c.id, order: index + 1 })
                        .catch(error => {
                          check + 1
                          console.log(error)
                        })
                    } else {
                      incopt.push(o)
                      this.$axios.patch(`/options/${o}/`, { clazz: c.id, order: index + 1 })
                        .catch(error => {
                          check + 1
                          console.log(error)
                        })
                    }
                  })
                } else {
                  this.options.forEach(opt => {
                    this.$axios.patch(`/options/${opt.id}/`, {clazz: null, order: 0 })
                      .catch(error => {
                        check + 1
                        console.log(error)
                      })
                  })
                }
              })
              .catch(error => {
                check + 1
                console.log(error)
              })
          } else {
            if (c.title) {
              let data = {
                order: index + 1,
                title: c.title,
                description: c.description,
                product: c.product,
                locale: this.language,
                features: [...c.features],
                default_option: (typeof(c.default_option) === "object" ? c.default_option.id : c.default_option)
              }
              this.$axios.post('/clazzs/', data)
                .then(resp => {
                  let id = resp.data.id
                  if (c.options.length > 0) {
                    c.options.forEach((o, index) => {
                      this.$axios.patch(`/options/${o}/`, { clazz: id, order: index + 1 })
                        .catch(error => {
                          check + 1
                          console.log(error)
                        })
                    })
                  }
                })
                .catch(error => {
                  this.check.push(false)
                  console.log(error)
                })
            } else {
              this.$alert.failed('No Data!')
            }
          }
        })
        setTimeout(() => {
          this.options.forEach(opt => {
          // console.log(JSON.stringify(incopt), opt.id, incopt.includes(opt.id))
            if (!incopt.includes(opt.id)) {
              this.$axios.patch(`/options/${opt.id}/`, { clazz: null, order: 0 })
                .catch(error => {
                  check + 1
                  console.log(error)
                })
            }
          })
        }, 1000)
        if (check > 0) {
          this.$alert.failed('Error')
        } else {
          this.$alert.success('Save Class Success')
        }

      } else {
        this.$alert.failed('No Data!')
      }
      this.$emit('save')
      // this.$alert.success('Save Class Success')
    },
    removeClazz (cid, e) {
      this.clazz.splice(e, 1)
      this.deleteClazz(cid)
    },
    deleteClazz (cid) {
      this.$axios.delete(`/clazzs/${cid}/`)
        .then(resp => {
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeOrderUp (index) {
      let item = this.clazz.slice(index, index + 1)
      this.clazz.splice(index, 1)
      this.clazz.splice(index - 1, 0, item[0])
      let defitem = this.defOptions.slice(index, index + 1)
      this.defOptions.splice(index, 1)
      this.defOptions.splice(index - 1, 0, defitem[0])
    },
    changeOrderDown (index) {
      let item = this.clazz.slice(index, index + 1)
      this.clazz.splice(index, 1)
      this.clazz.splice(index + 1, 0, item[0])
      let defitem = this.defOptions.slice(index, index + 1)
      this.defOptions.splice(index, 1)
      this.defOptions.splice(index + 1, 0, defitem[0])
    },
    senToRM (val) {
      return (parseInt(val)/100).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>